import renderIcon, { IconName } from 'helpers/renderIcon';
import * as React from 'react';
require('./style.css');

interface IProps {
	keyword?: string;
	t: any;
	iconName?: IconName;
	subMessage?: string;
}

const NoResults = ({ keyword, t, iconName, subMessage }: IProps) => {
	const emptyResults = (
		<>
			{renderIcon(iconName ? iconName : 'missing', 25)}
			<p className="p18">{`${t('User_UserCard_NothingHereYet')}${keyword ? ` ${keyword}` : ''}`}</p>
			{subMessage ? <p className="p14">{t(subMessage)}</p> : null}
		</>
	);

	return (
		<div className="noResults empty d-flex flex-column justify-content-center align-items-center">{emptyResults}</div>
	);
};

export { NoResults };
